import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface Requisite {
  id: number;
  businessProfileId: number;
  displayName: string;
  isDeleted: boolean;
  inn: number;
  kpp: string;
  ogrn: string;
  bankAccount: string;
  bankName: string;
  bik: string;
  correspondentAccount: string;
  address: string;
  phone: string;
  email: string;
  currency: number;
  billable: boolean;
}

export interface RequisiteCreate {
  displayName: string;
  inn: number;
  kpp: string;
  ogrn: string;
  bankAccount: string;
  bankName: string;
  bik: string;
  correspondentAccount: string;
  address: string;
  phone: string;
  email: string;
  currency: number;
  billable: boolean;
}

export interface RequisiteUpdate {
  displayName: string;
  inn: number;
  kpp: string;
  ogrn: string;
  bankAccount: string;
  bankName: string;
  bik: string;
  correspondentAccount: string;
  address: string;
  phone: string;
  email: string;
  currency: number;
  billable: boolean;
}

// TODO: пофиксить тайпинг
export interface RenterRequisite extends Requisite {
  display_name: string;
  renter_id: number;
}

export function RequisitesAPI(baseUrl: string) {
  return {
    list: async () => {
      return (await crud.get(
        `${baseUrl}/business-requisites`,
        undefined,
        true,
      )) as Requisite[];
    },
    // TODO: перенести это в кор
    getRenterRequisites: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/requisites/renters?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<RenterRequisite[]>;
    },
    get: async (id: number) => {
      return (await crud.get(
        `${baseUrl}/business-requisites/${id}`,
        undefined,
        true,
      )) as Requisite;
    },
    create: async (params: RequisiteCreate) => {
      return (await crud.post(
        `${baseUrl}/business-requisites`,
        params,
        true,
      )) as Requisite;
    },
    update: async (id: number, params: RequisiteUpdate) => {
      return (await crud.patch(
        `${baseUrl}/business-requisites/${id}`,
        params,
        true,
      )) as Requisite;
    },
    delete: async (id: number) => {
      return (await crud.delete(
        `${baseUrl}/business-requisites/${id}`,
        true,
      )) as ApiResponse<{}>;
    },
  };
}
